import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-skin-diagnostic"
    path="business/products/ai-skin-diagnostic"
    element={<AsyncPage />}
  />,
  // <Route
  //   key="/ja/business/products/ai-skin-diagnostic"
  //   path="ja/business/products/ai-skin-diagnostic"
  //   element={<AsyncPage />}
  // />,
];
